import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  max-height: 95dvh;
  max-width: 400px;
  position: relative;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  /* Keep visible so the ExplosionButton glow/explosion in the footer is not clipped */
  overflow: visible;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #142743;
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;

  /* Content scrolls here so the outer container can keep overflow visible */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalFooter = styled.div`
  flex-shrink: 0;
  padding: 12px 16px 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ModalTitle = styled.h2`
  font-family: Figtree;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.1px;
  text-align: left;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: 100%;
  justify-content: space-between;
`;
export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;
export const IconButton = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const LabelText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  text-align: left;
`;

export const Textarea = styled.textarea`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #325682;
  background: #142743;
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  resize: vertical;
  min-height: 126px;
  outline: none;

  &::placeholder {
    color: #71717a;
  }
`;

export const AspectRatioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const AspectRatioOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  padding: 12px 0;
  cursor: pointer;
  border-radius: 12px;
  background: ${(p) => (p.$selected ? "transparent" : "#142743")};
  border: ${(p) => (p.$selected ? "1px solid #2877d9" : "1px solid #325682")};
  transition: border 0.2s ease;
`;

export const AspectRatioPreviewWrapper = styled.div`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AspectRatioPreview = styled.div`
  width: ${(p) => p.$width}px;
  height: ${(p) => p.$height}px;
  border-radius: 4px;
  background: ${(p) => (p.$selected ? "#2877D9" : "#274772")};
  border: ${(p) => (p.$selected ? "none" : "1px solid #223f68")};
  transition: all 0.2s ease;
`;

export const AspectRatioLabel = styled.span`
  font-family: Figtree;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.21px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  svg {
    width: 16px;
    height: 16px;
    opacity: 0.5;

    path {
      stroke: ${(p) => (p.$active ? "rgba(63, 136, 247, 1)" : "#fff")};
    }
  }
`;

export const TooltipContainer = styled.div`
  border-radius: 16px;
  border: 1px solid #142743;
  background: #081120;
  padding: 16px;
  position: absolute;
  top: 24px;
  left: -24px;
  width: min(340px, calc(100vw - 72px));
  max-height: 180px;
  overflow-y: auto;
  gap: 8px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  opacity: 1;
  text-align: left;
`;

export const TooltipText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
  margin: 0;
  word-break: break-word;
`;

export const CheckboxContainerColumn = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
  width: 100%;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  padding: 6px 8px;
  background: #0e1c31;
  border-radius: 12px;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  align-self: stretch;
  border: 0.5px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.37);
  border-radius: 100px;
  flex-direction: row;
  height: 33px;
`;

export const CheckboxText = styled.div`
  position: relative;
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;
